module.exports = __webpack_public_path__ + "img/LBA-Business.9b3d59eb.svg";